import { Component } from 'react'

export default class extends Component {
    render() {
        return (
            <>
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, .4)', zIndex: '11111', display: this.props.visible ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center' }}>
                    <div className={this.props.customClass}>
                        <div className="card rounded-4">
                            <div className="card-body py-2 text-center d-flex flex-column justify-content-center align-items-center" style={{gap:'24px'}}>
                                <h5 className='mb-0 mt-3'>{this.props?.titleMessage}</h5>
                                <iframe className="iframe-pdf" src={this.props.file} frameBorder="0"></iframe>
                                <button className="btn btn-login my-1" style={{paddingLeft:'70px', paddingRight:'70px', paddingBottom:'10px', paddingTop:'10px'}} onClick={ this.props.onClick }>Oke</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
